module.exports = __webpack_public_path__ + "img/section-valid.66b3e3c2.png";